<header class="app-header navbar navbar-expand-lg d-flex">
    
    <!-- button class="navbar-toggler d-lg-none" type="button" appMobileSidebarToggler>
    <span class="navbar-toggler-icon"></span>
  </button -->

  <a class="navbar-brand" href="#"></a>

  <div class="d-flex">
    <div>
      <button class="navbar-toggler d-lg-none" type="button" 
        data-bs-toggle="collapse"
        data-bs-target="#navbarSupportedContent" 
        aria-controls="navbarSupportedContent" 
        aria-expanded="false" 
        aria-label="Toggle navigation"
        appMobileSidebarToggler>
        <span class="navbar-toggler-icon"></span>
    </button>
    </div>
  </div>

  <div class="d-flex navbar-collapse flex-row-reverse" id="navbarSupportedContent">
    
      <!-- div class="table-responsive-mds">
      <table class="table">
        <tr>
          <td style="padding-top: 15px;">
            <app-license-component></app-license-component>
          </td>
          <td style="width:180px">
            <app-datepicker></app-datepicker>
          </td>
          <td>
            <app-project-selector></app-project-selector>
          </td>
        </tr>
      </table>
      </div -->
      
    <div class="p-2">
      <app-project-selector></app-project-selector>
    </div>

    <!-- div class="p-2 mw-50" >
      <app-datepicker></app-datepicker>
    </div -->

    <!-- div class="p-2 dropdown">
      <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenu2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        Dropdown
      </button>
      <div class="dropdown-menu" aria-labelledby="dropdownMenu2">
        <button class="dropdown-item" type="button">Action</button>
        <button class="dropdown-item" type="button">Another action</button>
        <button class="dropdown-item" type="button">Something else here</button>
      </div>
    </div -->

    <div class="p-2">
      <app-license-component></app-license-component>
    </div>
    
  </div>

</header>
